import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { HxStoreService } from '../services/store.service';
import { StoreFullModel } from '../vn-api';

export const storeResolveFn: ResolveFn<StoreFullModel> = route => inject(HxStoreService).getFullStore(Number(route.paramMap.get('storeId')));
